import { render, staticRenderFns } from "./TableReceive.vue?vue&type=template&id=4da7fabf&scoped=true"
import script from "./TableReceive.vue?vue&type=script&lang=js"
export * from "./TableReceive.vue?vue&type=script&lang=js"
import style0 from "./TableReceive.vue?vue&type=style&index=0&id=4da7fabf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da7fabf",
  null
  
)

export default component.exports